import { render } from "./areaTeaSubjectEchart.vue?vue&type=template&id=0f8a4652&scoped=true"
import script from "./areaTeaSubjectEchart.vue?vue&type=script&lang=js"
export * from "./areaTeaSubjectEchart.vue?vue&type=script&lang=js"

import "./areaTeaSubjectEchart.vue?vue&type=style&index=0&id=0f8a4652&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8a4652"]])

export default __exports__